/**
 * Tour Registry
 * Central export for all tour definitions
 */

import type { Tour, TourId } from '@/types/onboarding';
import { quickStartTour } from './quick-start-tour';
import { researchTour } from './research-tour';
import { representativesTour } from './representatives-tour';
import { alertsTour } from './alerts-tour';
import { committeeTour } from './committee-tour';
import { billDetailsTour } from './bill-details-tour';

/** All available tours */
export const tours: Record<TourId, Tour> = {
  'quick-start': quickStartTour,
  research: researchTour,
  representatives: representativesTour,
  alerts: alertsTour,
  committee: committeeTour,
  'bill-details': billDetailsTour,
};

/** Get a tour by ID */
export function getTour(tourId: TourId): Tour | undefined {
  return tours[tourId];
}

/** Get all tours as an array */
export function getAllTours(): Tour[] {
  return Object.values(tours);
}

// Re-export individual tours
export { quickStartTour } from './quick-start-tour';
export { researchTour } from './research-tour';
export { representativesTour } from './representatives-tour';
export { alertsTour } from './alerts-tour';
export {
  committeeTour,
  TOUR_RESUME_KEY,
  saveTourResumeState,
  consumeTourResumeState,
  type TourResumeState,
} from './committee-tour';
export { billDetailsTour } from './bill-details-tour';
